import { Link } from 'react-router-dom';
import { newMovies } from '@/mocks/movies';

export default function LatestMovies() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新上映
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新上线的院线大片，第一时间观看</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="true">
          {newMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group block bg-background-50 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={movie.poster}
                  alt={`${movie.title} - 小草影院最新上映`}
                  title={`${movie.title}在线观看 - 小草影院`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {movie.subCategory}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-background-950/80 to-transparent">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    <span className="text-xs text-background-100 font-medium">{movie.rating}</span>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 truncate font-heading">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 flex items-center gap-2">
                  <span>{movie.year}</span>
                  <span className="text-foreground-300">|</span>
                  <span>{movie.releaseDate} 上映</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}